define('models/user/register/eligibility',["backbone", "models/shared/lookups/systext"
], function (Backbone, SystemText) {
    var Eligibility = Backbone.Model.extend({
        urlRoot: function () {
            if (this.instanceURL)
                return this.instanceURL;

            if(this.attributes.appendEGUID){
                return pf.userURL + "/Eligibility/" + this.attributes.EGUID;
            }

            if (this.appendEGUID){
                return pf.userURL + "/Eligibility/" + this.EGUID;
            } else {
                return pf.userURL + "/Eligibility";
            }
        },
        save: function (attributes, options) {
            options = options || {};
            attributes = attributes || {};

            var data = {};
            data.EGUID = this.attributes.EGUID;
            /* modified Palash to include DOB */
            data.DOB = this.attributes.DOB;
            /* modified Palash to include DOB */
            /* modified Palash to include SSN4 */
            data.SSN4 = this.attributes.SSN4;
            /* modified Palash to include SSN4 */
            data.FN = this.attributes.FirstName;
            data.MN = this.attributes.MiddleName;
            data.LN = this.attributes.LastName;
            data.E = this.attributes.Email;
            data.PD = this.attributes.Password;
            data.G = this.attributes.Gender;
            data.C = this.attributes.City;
            data.S = this.attributes.State;
            data.Z = this.attributes.ZipCode
            data.PH = this.attributes.PhoneNumber;
            data.UTID = 1;
            data.ET = 1;
            data.MSID = 0;
            data.FP = this.attributes.Fingerprint;
            data.OP = this.attributes.Optional;
            data.WS = this.attributes.Website;
            data.CGUID = this.attributes.CampaignCode;
            data.U = this.attributes.Unsubscribe;
            data.IC = this.attributes.InvitationCode;
            data.ICR = this.attributes.InvitationCodeResponse;
            data.RC = this.attributes.ReferralCode;
            data.IMA = this.attributes.IsMobileApp;
            data.IM = this.attributes.IsMobile;
            data.UG = this.attributes.UserGUID;
            data.IAM = this.attributes.IsAnthemMember;
            this.attributes = data;

            return Backbone.Model.prototype.save.call(this, attributes, options);
        },
        initialize: function (options) {
            options = options || {};

            this.EGUID = options.EGUID;
            this.appendEGUID = options.appendEGUID;
            this.SSN4 = options.SSN4;
            this.FN = options.FirstName;
            this.MN = options.MiddleName;
            this.LN = options.LastName;
            this.E = options.Email;
            this.C = options.City;
            this.S = options.State;
            this.Z = options.ZipCode;
            this.G = options.Gender;
            this.OP = options.Optional;
            this.WS = options.Website;
            this.CGUID = options.CGUID;
            this.U = options.Unsubscribe;
            this.IC = options.InvitationCode;
            this.ICR = options.InvitationCodeResponse;
            this.RC = options.ReferralCode;
            this.UG = options.UserGUID;
            this.IAM = options.IsAnthemMember;
        }
    });
    return Eligibility;
});

